import { useMutation, useQueryClient } from '@tanstack/react-query'

import { restoreProfessional } from 'src/lib/sante-api/professionals'

import { getQueryFromSessionStorage } from './useFetchProfessionalsQuery'

/**
 * @param {import('@tanstack/react-query').UseMutationOptions} options
 * @returns {import('@tanstack/react-query').UseMutationResult}
 */
export function useRestoreProfessionalMutation(options = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: restoreProfessional,
    onSettled: () => {
      const queryKey = getQueryFromSessionStorage()

      if (queryKey) queryClient.invalidateQueries({ queryKey })
    },
  })
}
